module.exports = __webpack_public_path__ + "media/fonts/Oricons-e665095f0587a6e0c7f4bd5766f1f516.woff2";